<template>
    <div class="search-bar" :style="{ width: size + '%' }">
        <input
            v-model="searchQuery"
            @keyup.enter="submitSearch"
            placeholder=""
            :disabled="disabled"
        />
        <button :disabled="disabled" @click="submitSearch">
            <!-- <i class="fas fa-search"></i> -->
            <!-- Font Awesome 사용 -->
            <font-awesome-icon icon="search"></font-awesome-icon>
        </button>
    </div>
</template>

<script>
import { ref, defineComponent, onMounted, onUpdated } from "vue";

export default defineComponent({
    props: {
        size: {
            type: Number,
            default: 100,
        },
        text: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const searchQuery = ref("");

        const submitSearch = () => {
            // 검색 로직을 실행합니다.
            // 이벤트를 발생시켜 부모 컴포넌트로 검색 데이터를 전달할 수 있습니다.
            emit("onSearch", searchQuery.value); // 부모 컴포넌트로 이벤트 방출
        };

        onMounted(() => {
            searchQuery.value = props.text;
        });

        onUpdated(() => {
            if (props.disabled) {
                searchQuery.value = props.text;
            }
        });

        return {
            searchQuery,
            submitSearch,
        };
    },
});
</script>

<style scoped>
.search-bar {
    display: flex;
    width: 888px;
    height: 56px;
    align-items: center;
    border: 1px solid #aaaaaa;
    border-radius: 25px;
    padding: 5px 10px;
}

.search-bar input {
    border: none;
    outline: none;
    flex-grow: 0.96;
    padding: 8px 10px;
    font-size: 16px;
}

.search-bar button {
    background: none;
    border: none;

    color: #000000;
}

.search-bar button i {
    font-size: 20px;
}
</style>
